
$(function () {

    $(document).on('click', '._js-tabs-link', function(e) {
        e.preventDefault(); // Prevent default link behavior.
        var tabID = $(this).attr('data-target'); // Pull the data-target value as the tabID.

        $(this).addClass('_active').parent().addClass('_active'); // Add the ._active class to the link and it's parent li (if one exists).
        $(this).siblings().removeClass('_active'); // Remove the ._active class from sibling tab navigation elements.
        $(this).parent('li').siblings().removeClass('_active').children().removeClass('_active'); // Remove the ._active class from sibling li elements and their links.
        $(tabID).addClass('_active'); // Add the ._active class to the div with the tab content.
        $(tabID).siblings().removeClass('_active'); // Remove the ._active class from other tab content divs.
    });

});
